import { render, staticRenderFns } from "./DefaultAvatarIcon.vue?vue&type=template&id=01e324ca&scoped=true"
import script from "./DefaultAvatarIcon.vue?vue&type=script&lang=js"
export * from "./DefaultAvatarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e324ca",
  null
  
)

export default component.exports